import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewLineOfBusinessComponent } from './new-line-of-business.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { VerticalMenuModule } from '../vertical-menu/vertical-menu.module';
import { NewSolutionCardModule } from 'src/app/components/solutions/new-solution-card/new-solution-card.module';

@NgModule({
  declarations: [
    NewLineOfBusinessComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    VerticalMenuModule,
    NewSolutionCardModule
  ],
  exports: [
    NewLineOfBusinessComponent,
  ]
})
export class NewLineOfBusinessModule { }
